// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__-qBY5","info":"UpdateTermsInfo_info__koeha"};